import { Button } from '@flipster/ui/Button';
import ConvertIcon from '@flipster/ui/assets/svgs/convert.svg';

import styles from './historyPage.module.scss';

interface Props {
  desc?: string;
  refetch: () => void;
}

const ResetSection = ({ desc, refetch }: Props) => {
  return (
    <div className={styles.right}>
      {desc && <span className={styles.desc}>{desc}</span>}
      <Button shape='tertiary' onClick={refetch} className={styles.refresh}>
        <ConvertIcon />
        Refresh
      </Button>
    </div>
  );
};

export default ResetSection;
